import React from "react";
import { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { Overlay, Popover, Button } from "react-bootstrap";
import NotificationPopover from "../Utility/NotificationPopover";
import DoctorProfilePopover from "../Utility/DoctorProfilePopover";
import PatientsPopoverItems from "../Dropdowns/PatientsPopoverItems";
import { Collapse, Divider } from "antd";
import { CaretDownOutlined } from "@ant-design/icons"; // Ant Design iconi
import WardPopoverItems from "../Dropdowns/WardPopoverItems";
import PurchasePopoverItems from "../Dropdowns/PurchasePopoverItems";
import SalePopoverItems from "../Dropdowns/SalePopoverItems";
import PharmacyProfilePopover from "../Utility/PharmacyProfilePopover";
function PharmacySidebar() {
  const navigate = useNavigate();


  const [show, setShow] = useState(false);
  const target = useRef(null);

  const name = "Seveli Clinic"; // replace with dynamic value
  const getInitials = (name) => {
    const names = name.trim().split(" ");
    const initials = names
      .map((n) => n[0])
      .join("")
      .toUpperCase();
    return initials.slice(0, 2); // Only first two initials
  };

  const profileNameData = {
    basicinfo: {
      fullname: "Dr. Jane Smith",
      imageURL: "",
      clinic_Hospital_Name: "Seveli Clinic",
      logoUpload: "",
    },
    professionalinfo: {
      specialization: "Pharmacist",
      rolename: "Senior Consultant",
    },
  };

  const handleToggle = () => setShow(!show);

  const [isFullscreen, setIsFullscreen] = useState(
    !!document.fullscreenElement
  );

  const toggleFullscreen = async () => {
    if (!document.fullscreenElement) {
      try {
        await document.documentElement.requestFullscreen();
        setIsFullscreen(true);
      } catch (err) {
        console.error("Fullscreen request denied:", err);
      }
    } else {
      try {
        await document.exitFullscreen();
        setIsFullscreen(false);
      } catch (err) {
        console.error("Exit fullscreen failed:", err);
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);
  const items2 = [
    {
      key: "1",
      label: (
        <div className="d-flex align-items-center" style={{ gap: "1.6rem" }}>
          <img
            style={{ height: ".8rem" }}
            src="\Images\Icons\Purchase -2_1.svg"
            alt="Patient"
          />
          <span style={{ color: "#fff" }}>Purchase</span>
        </div>
      ),
      children: (
        <ul className="mb-0 ">
          <li className="mb-1">
            <a
              onClick={() =>
                navigate('/PharmacyPurchase1')
              }
              className="doctor-link" 
            >
              Purchase
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate('/PurchaseOrder')}
              className="doctor-link"
            >
              Add Purchase
            </a>
          </li>
          <li className="mb-1">
            <a
              onClick={() =>
                 navigate("/PharmacyPurchasereturn", { 
    state: { 
      openModal: true 
    } 
  })
              }
              className="doctor-link"
            >
              Purchase Return
            </a>
          </li>
        </ul>
      ),
    },
  ];

  const salesItems = [
    {
      key: "1",
      label: (
        <div className="d-flex align-items-center" style={{ gap: "1.6rem" }}>
          <img
            style={{ height: ".8rem" }}
            src="\Images\Icons\Sales - 4_1.svg"
            alt="Patient"
          />
          <span style={{ color: "#fff" }}>Sales</span>
        </div>
      ),
      children: (
        <ul className="mb-0 ">
          <li className="mb-1">
            <a
              onClick={() =>
                navigate('/sales/invoices')
              }
              className="doctor-link" 
            >
              Sales Invoice
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate('/sales/add-return')}
              className="doctor-link"
            >
              Sale Return
            </a>
          </li>
        </ul>
      ),
    },
  ];


  const [sidenavopen, setSideNavOpen] = useState(true);
 const style = `

.hover-bg:hover {
  background-color: #f5f5f5;
}

    .accordion-button {
          padding: unset !important;
    height: 2rem !important;
    max-width: unset !important;
    display: flex;
    flex-direction: row;
    border: unset;
    }

    .accordion-item{
      border: unset !important;
    }

    .accordion-button::after {
    flex-shrink: 0;
    width: 0.8rem;
    height: 0.8rem;
    margin-left: auto;
    margin-right: 1rem;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: cover;
    transition: var(--bs-accordion-btn-icon-transition);
}

  .accordion-button:not(.collapsed) {
    color: unset;
    background-color: unset;
    box-shadow: unset;
}

  .accordion-button:focus {
    z-index: 3;
    outline: 0;
    box-shadow: unset;
}

/* ========== Accordion Header ========== */
.doctor-collapse .ant-collapse-header {
  padding: 12px 16px;
  margin-left: .5rem;
  transition: background-color 0.3s;
  font-weight: 400;
  font-size: .8rem !important;
  border-radius: 6px !important; /* ✅ Rounded corners */
  background-color: transparent;
  color: white !important; /* ✅ White text by default */
}

/* Hover effect (no color change, just background) */
.doctor-collapse .ant-collapse-header:hover {
  background-color: rgba(255, 255, 255, 0.1); /* Light hover effect */
  color: white !important;
  border-radius: 10px;
}

/* Chevron icon to the right */
.doctor-collapse .ant-collapse-expand-icon {
  order: 2;
  margin-inline-start: auto;
  color: white; /* ✅ Chevron icon color white */
}

/* ========== Inner Link Styles ========== */
.doctor-link {
  color: white !important; /* ✅ White link text */
  text-decoration: none;
  padding: 4px 8px;
  display: block;
  border-radius: 4px;
  font-size: .8rem !important;
  transition: background-color 0.3s;
  font-size: 14px;
}

/* Hover on links */
.doctor-link:hover {
  background-color: rgba(255, 255, 255, 0.15); /* soft highlight */
  color: white !important; /* keep text white */
}

/* Optional: Panel background transparent */
.doctor-collapse .ant-collapse-content {
  background-color: transparent !important;
}




  `;

  return (
    <>
      <style>{style}</style>
      <div style={{ height: "100%" }} className="row gx-0">
        <nav
          container
          className={sidenavopen ? "sidebar col-md-2" : "collapsed sidebar"}
        >
          <div className="sidebar-bg" />
          <button
            onClick={() => setSideNavOpen(!sidenavopen)}
            className="expand-btn"
          >
            <i
              class="fa-regular fa-square-caret-left"
              style={{ color: "#3cc245" }}
            ></i>
          </button>

          <div class="sidebar-links">

            {profileNameData && (
              <div className="d-flex align-items-center gap-3 mb-3">
                <img
                  className=""
                  style={{
                    height: "3rem",
                    width: "3rem",
                    marginLeft: "0.1rem",
                    borderRadius: "50%",
                  }}
                  src={profileNameData?.basicinfo?.imageURL || 'https://images.rawpixel.com/image_800/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcm0zNzNiYXRjaDE1LTIxNy0wMS5qcGc.jpg'}
                  alt=""
                  srcset=""
                />
                <div>
                  <h5
                    className=""
                    style={{ display: !sidenavopen ? "none" : "block", color: "#fff" }}
                  >
                    {profileNameData?.basicinfo?.fullname}
                  </h5>
                  <p style={{ display: !sidenavopen ? "none" : "block", color: "#fff", fontSize: '12px' }}>{profileNameData?.professionalinfo?.specialization}</p>
                </div>
              </div>
            )}

            <div class="TvZMhVkOCp"></div>
            <ul>
              <li>
                <Link to="/PharmacyDashboard" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img className="h-50" src="\Images\Dashboard.svg" alt="Dashboard" />
                  <p className="div-atagcolor">Dashboard</p>
                </Link>
              </li>
               {/* <li>
                <Link to="/PharmacyPurchase1" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img className="h-50" src="/Images/Dashboard.svg" alt="Dashboard" />
                  <p className="div-atagcolor">Purchase</p>
                </Link>
              </li> */}
              {!sidenavopen ? (
                  <li className="mb-2">
                    <PurchasePopoverItems />
                  </li>
                ) : (
                  <li className="">
                    <Collapse
                      items={items2}
                      expandIconPosition="end"
                      bordered={false}
                      className="doctor-collapse"
                      style={{
                        transition: "all 0.3s ease-in-out",
                        backgroundColor: "transparent",
                      }}
                      expandIcon={({ isActive }) => (
                        <CaretDownOutlined
                          style={{
                            fontSize: "14px",
                            color: "white",
                            transform: isActive
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s",
                          }}
                        />
                      )}
                    />
                  </li>
                )}
               <li>
                <Link to="/StockComponentScreen" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img className="h-50" src="\Images\Icons\Stock - 3.svg" alt="Dashboard" />
                  <p className="div-atagcolor">Stock</p>
                </Link>
              </li>
                
                {!sidenavopen ? (
                  <li className="mb-2">
                    <SalePopoverItems />
                  </li>
                ) : (
                  <li className="">
                    <Collapse
                      items={salesItems}
                      expandIconPosition="end"
                      bordered={false}
                      className="doctor-collapse"
                      style={{
                        transition: "all 0.3s ease-in-out",
                        backgroundColor: "transparent",
                      }}
                      expandIcon={({ isActive }) => (
                        <CaretDownOutlined
                          style={{
                            fontSize: "14px",
                            color: "white",
                            transform: isActive
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s",
                          }}
                        />
                      )}
                    />
                  </li>
                )}
              <li>
                <Link to="/PharmacyCustomerorders" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img className="h-50" src="\Images\Icons\Customer Order - 6_1.svg" alt="Appointments" />
                  <p className="div-atagcolor">Customer Orders</p>
                </Link>
              </li>
              <li>
                <Link to="/PharmacyOrderdashboard" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img className="h-50" src="\Images\Icons\Order Dashborad - 7_1.svg" alt="Appointments" />
                  <p className="div-atagcolor">Order Dashboard</p>
                </Link>
              </li>
              {/* <li>
                <Link to="/PharmacyPescription" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img
                    className="h-50"
                    style={{ height: "1.5rem" }}
                    src="/Images/Prescription.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Prescription</p>
                </Link>
              </li> */}
              <li>
                <Link to="/Procurement" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img
                    className="h-50"
                    style={{ height: "1.5rem" }}
                    src="\Images\Icons\Prescription -8_1.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Patient Follow Up</p>
                </Link>
              </li>
              {/* <li>
                <Link to="/PharmacyExpenses" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img className="h-50" src="/Images/Departments.svg" alt="Appointments" />
                  <p className="div-atagcolor">Expenses</p>
                </Link>
              </li> */} 
              <li>
                <Link to="/PharmacyMultibranches" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img className="h-50" src="\Images\Icons\Multi - Branch Transfer -10_1.svg" alt="Appointments" />
                  <p className="div-atagcolor">Multi-Branch Transfer</p>
                </Link>
              </li>
              <li>
                <Link to="/PharmacyDistribution" className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden">
                  <img className="h-50" src="\Images\Icons\Disturbution - 11_1.svg" alt="Appointments" />
                  <p className="div-atagcolor">Distributor</p>
                </Link>
              </li>

            </ul>
          </div>
          <div className="d-flex flex-col gap-3 mt-3">
            <div class="TvZMhVkOCp"></div>
            <h5
              className=""

            >
              <div className="d-flex align-items-center gap-3 ms-2">
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    backgroundColor: "#E4E6EB",
                    color: "#000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "600",
                    fontSize: "14px",
                    overflow: "hidden", // ensures image is clipped into circle
                  }}
                >
                  {profileNameData?.basicinfo?.logoUpload ? (
                    <img
                      src={profileNameData?.basicinfo?.logoUpload}
                      alt="avatar"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    getInitials(name)
                  )}
                </div>
                <div style={{ display: !sidenavopen ? "none" : "block" }}>
                  <div className="d-flex flex-column gap-1">
                    <div>{profileNameData?.basicinfo?.clinic_Hospital_Name}</div>
                    <p className="text-sm">{profileNameData?.basicinfo?.rolename}</p>
                  </div>
                </div>
              </div>
            </h5>
          </div>
        </nav>
        <div
          style={{
            display: "flex",
            flexGrow: "1",
            padding: "unset",
            height: "100%",
          }}
          className="col-md-10"
        >
          <div className="col-12 g-0 div-colcon">
            <div className="div-TM1vTuWchY flex-jt-sb">
              <div class="sidebar-top">
                <div class="logo__wrapper">
                  <div style={{ width: "15rem", marginLeft: "2rem" }}>
                    <img
                      style={{}}
                      src="/Images/Logo.png"
                      alt="Logo"
                      class="logo-small"
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-center gap-3 div-W1ShPmHBDd">
                {/* Fullscreen Button */}
                <button
                  onClick={toggleFullscreen}
                  className="btn d-flex align-items-center justify-content-center"
                  title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                  style={{ padding: "0.5rem", fontSize: "1rem" }}
                >
                  <i
                    className={`fa-solid ${isFullscreen ? "fa-compress" : "fa-expand"
                      }`}
                  ></i>
                </button>

                {/* Profile Button */}
                
                <NotificationPopover />
                <PharmacyProfilePopover />
              </div>

              <header id="hamburger-hd">
                <input type="checkbox" id="menyAvPaa" />
                <label id="burger" for="menyAvPaa">
                  <div></div>
                  <div></div>
                  <div></div>
                </label>
                <nav id="meny">
                  <div style={{ height: "100%", backgroundColor: "#213343" }} class="d-flex flex-column">
                    <div class="div-mV3nDcsCXh">
                      {profileNameData && <div className="d-flex align-items-center gap-3 mt-3">
                        <img
                          className=""
                          style={{ height: "2.5rem", marginLeft: "0.5rem", borderRadius: '50%' }}
                          src={profileNameData?.basicinfo?.imageURL}
                          alt=""
                          srcset=""
                        />
                        <h5 className="text-white mb-0" style={{ display: !sidenavopen ? 'none' : 'block' }}>
                          {profileNameData?.basicinfo?.fullname}
                        </h5>
                      </div>}

                      <span
                        style={{ fontSize: "16px", fontWeight: "600" }}
                      ></span>
                    </div>
                    <div class="TvZMhVkOCp mt-3"></div>
                    <div class="div-XbccJyGpRY">
                      <div class="d-flex flex-column div-Yb0Usyx31B">
                        {/* ///   <span class="spn-HX8Z7l2ITc text-white">Doctor</span> */}
                        <ul class="ul-WvVKfbP6Pb">
                          <li>
                            <a
                              href="/PharmacyDashboard"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Dashboard"
                            >
                              <img
                                className="h-50"
                                src="/Images/Dashboard.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">DashBoard</span>
                            </a>
                          </li>
                          {!sidenavopen ? (
                            <li >
                              <WardPopoverItems />
                            </li>
                          ) : (
                            <li>
                              <Collapse
                                items={items2}
                                expandIconPosition="end"
                                bordered={false}
                                className="doctor-collapse"
                                style={{
                                  transition: "all 0.3s ease-in-out",
                                  backgroundColor: "transparent",
                                }}
                                expandIcon={({ isActive }) => (
                                  <CaretDownOutlined
                                    style={{
                                      fontSize: "14px",
                                      color: "white",
                                      transform: isActive
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                      transition: "transform 0.3s",
                                    }}
                                  />
                                )}
                              />
                            </li>
                          )}

                          <li>
                            <a
                              href="/PharmacyOrderdashboard"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="\Images\Icons\Customer Order - 6_1.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Customer Orders</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/PharmacyOrderdashboard"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <img
                                className="h-50"
                                src="\Images\Icons\Order Dashborad - 7_1.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Order Dashboard</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/PharmacyPescription"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Settings"
                            >
                              <img
                                className="h-50"
                                src="/Images/Tratment Plan.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Pescription</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/PharmacyExpenses"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Payments"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Patients.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Expenses</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/PharmacyMultibranches"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Payments"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="\Images\Icons\Multi - Branch Transfer -10_1.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Multi-Branch Transfer</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/PharmacyDistribution"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Payments"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="\Images\Icons\Disturbution - 11_1.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Distributor</span>
                            </a>
                          </li>

                        </ul>
                      </div>
                    </div>
                  </div>
                </nav>
              </header>
            </div>
            <div id="dash-con">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PharmacySidebar;